import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  DomainObject,
  abortableFetch,
  useEventCallback,
} from '@eas/common-web';
import { CollectionDialog } from '../collection-dialog';
import { useValidationSchema } from '../collection-schema';
import { CollectionToolbarAction } from '../collection-toolbar';

export function useAssignCollectionDialog<T extends DomainObject>(
  getUrl: (id: string, collectionId: string) => string
) {
  const callApi = useEventCallback(
    (id: string, collectionId: string, formData: T) => {
      return abortableFetch(`${getUrl(id, collectionId)}`, {
        method: 'PUT',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
        body: JSON.stringify(formData),
      });
    }
  );

  return {
    callApi,
  };
}

export function resolveAssignAction<T extends DomainObject>(
  props: CollectionToolbarAction<typeof useAssignCollectionDialog<T>, T>
) {
  return {
    hide: false,
    useApi: useAssignCollectionDialog,
    label: (
      <FormattedMessage
        id="ZSD__COLLECTIONS__ASSIGN_LABEL"
        defaultMessage="Pridať"
      />
    ),
    title: (
      <FormattedMessage
        id="ZSD__COLLECTIONS__ASSIGN_TITLE"
        defaultMessage="Pridať"
      />
    ),
    text: (
      <FormattedMessage
        id="ZSD__COLLECTIONS__ASSIGN_TEXT"
        defaultMessage="Vyberte položku"
      />
    ),
    Dialog: CollectionDialog,
    dialogWidth: 400,
    useSchema: useValidationSchema,
    ...props,
  };
}
